module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-707-retro.3f666f73.jpg";